import type { FormikProps } from 'formik';

import './CustomerLeadStepQuantitiesTab.scss';

import { SelectField, TextInputField } from 'src/components/base';
import { TagListSelectField } from 'src/components/base/fields/TagListSelectField';
import type { ICustomerLeadProductInitialRequestTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import { CustomerLeadStepLayoutNextButton } from 'src/components/customers/steps/CustomerLeadStepLayoutNextButton';
import { useDebounceEffect } from 'src/hooks/useDebounceEffect';
import { CustomerLeadPurchaseReasonOptions } from 'src/types/customers/CustomerLeadPurchaseReason';
import { CustomerLeadUrgencyOptions } from 'src/types/customers/CustomerLeadUrgency';

type CustomerLeadStepContactTabProps = {
  formikProps: FormikProps<ICustomerLeadProductInitialRequestTabFormValues>;

  onChange: (newValues: ICustomerLeadProductInitialRequestTabFormValues) => void;
};

export function CustomerLeadStepInitialRequestTabContent({
  formikProps: { values, validateForm },
  onChange,
}: Readonly<CustomerLeadStepContactTabProps>) {
  useDebounceEffect(
    () => {
      void (async () => {
        const errors = await validateForm(values);

        if (Object.keys(errors).length === 0) {
          onChange(values);
        }
      })();
    },
    [values],
    1000
  );

  return (
    <div className="customer-lead-step-quantities-tab__container">
      <div className="customer-lead-step-quantities-tab__container__row">
        <SelectField
          name="urgency"
          label="Urgency"
          options={CustomerLeadUrgencyOptions}
          description="How urgent is the purchase? When do you need it by?"
        />
      </div>
      <div className="customer-lead-step-quantities-tab__container__row">
        <TextInputField
          name="maxQtySingleDelivery"
          label="Max Qty Single Delivery"
          description={`What is the maximum quantity of the product you'd be willing to receive?\nLarger quantities can lower shipping costs and provide more options.`}
        />
      </div>
      <div className="customer-lead-step-quantities-tab__container__row">
        <TagListSelectField
          name="purchaseReasons"
          label="Purchase Reasons"
          options={CustomerLeadPurchaseReasonOptions}
          description='What is your reason for shopping for "product"?'
          multiselect={true}
        />
      </div>

      <div className="customer-lead-step__layout__center__footer-actions">
        <CustomerLeadStepLayoutNextButton />
      </div>
    </div>
  );
}
